<script>
  export default {
    name: 'ReviewTable',
    components: {

    },
    filters: {

    },
    mixins: [],
    props: {
      members: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {

      }
    },
    computed: {
      membersLen() {
        const { members } = this
        return members && members.length
      }
    },
    watch: {

    },
    created() {

    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<template>
  <div class="review-table-wrap">
    <table class="review-table">
      <thead>
        <tr>
          <th colspan="2">
            风险识别
          </th>
          <th :colspan="membersLen">
            家庭成员
          </th>
          <th>建议</th>
        </tr>
        <tr class="subtitle">
          <th>风险分类</th>
          <th>风险描述</th>
          <th
            v-for="(mb, index) in members"
            :key="index"
          >
            {{ mb.name }}
          </th>
          <th />
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>身价保障 <span>意外，伤残保障</span></td>
          <td>无需担心自身收入能力减低或丧失谋生能力，是对自己和家人最大的重任</td>
          <td
            v-for="(mb, index) in members"
            :key="index"
            class="members-status"
          >
            <template v-if="mb.profitSummary">
              <i
                v-if="typeof mb.profitSummary[0] === 'number' && mb.profitSummary[0] > 0"
                class="icon-have"
              />
            </template>
          </td>
          <td>10倍年收入+负债</td>
        </tr>
        <tr>
          <td>大病保障 <span>轻症，重疾等</span></td>
          <td>专享诊疗金，解决后顾之忧，拒绝因病返贫</td>
          <td
            v-for="(mb, index) in members"
            :key="index"
            class="members-status"
          >
            <template v-if="mb.profitSummary">
              <i
                v-if="typeof mb.profitSummary[1] === 'number' && mb.profitSummary[1] > 0"
                class="icon-have"
              />
            </template>
          </td>
          <td>5倍年收入+负债</td>
        </tr>
        <tr>
          <td>医疗保障 <span>门急诊，百万医疗等</span></td>
          <td>昂贵的医疗费，社保无法报销的进口药，商业医疗险为你解决</td>
          <td
            v-for="(mb, index) in members"
            :key="index"
            class="members-status"
          >
            <template v-if="mb.profitSummary">
              <i
                v-if="typeof mb.profitSummary[2] === 'number' && mb.profitSummary[2] > 0"
                class="icon-have"
              />
            </template>
          </td>
          <td>享受高端医疗服务</td>
        </tr>
        <tr>
          <td>理财保障 <span>固定领取，万能账户</span></td>
          <td>教育金，养老金等，稳健为主，利益稳定，持续成长</td>
          <td
            v-for="(mb, index) in members"
            :key="index"
            class="members-status"
          >
            <template v-if="mb.profitSummary">
              <i
                v-if="typeof mb.profitSummary[3] === 'number' && mb.profitSummary[3] > 0"
                class="icon-have"
              />
            </template>
          </td>
          <td>养老金收入替代率60%以上教育金</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style scoped>
  @import 'variable.css';

  .review-table {
    thead {
      tr:first-child {
        th:nth-child(1) {
          width: 34%;
        }
        th:nth-child(3) {
          width: 20%;
        }
      }
      tr:last-child {
        th:first-child {
          border-right-color: #f8f8f8;
        }
      }
    }
    .subtitle {
      th {
        background-color: #f8f8f8;
      }
    }
    .members-status {
      text-align: center;
    }
    tbody {
      tr {
        td:first-child {
          background-color: #fdfdfd;
        }
        td:last-child {
          text-align: center;
        }
      }
      span {
        color: #999;
      }
    }
  }

  .icon-have {
    display: inline-block;
    width: 8px;
    height: 18px;
    border: 1px solid #ffb23e;
    border-left: none;
    border-top: none;
    transform: rotate(45deg);
  }
</style>